export default __webpack_public_path__ + "static/media/5054.a6ffbf19.png";